/* Styles */
import "../style/pages/home.scss";
/* JS */
import "core-js/modules/es.array.iterator";
import "./components/menu";
import "@wikicasa/common/lazy";
import {createApp, defineAsyncComponent} from "vue";
//@ts-ignore
import SearchMobile from "./vue/SearchMobile.vue";
import "bootstrap/js/dist/popover";
import axios from "axios";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import {useAppBanner} from "@wkComposables/useAppBanner";
import differenceInDays from "date-fns/differenceInDays";
import {Modals} from "./Types/Modals";
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import SearchBoxHome from "./vue/SearchBoxHome";
//@ts-ignore
import {useBreakpoints} from "@wkComposables/useBreakpoints";
//@ts-ignore
import {useFirebaseMessaging} from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import {createPinia, mapActions, mapState} from "pinia";

import {
    useBaseStore,
    useModalStore,
    useEmailConfirmStore,
    usePublicUserMenuStore,
    useLoggedUserStore
    //@ts-ignore
} from "@store/index"

const homeApp = createApp({
    name: "WikiHome",
    components: {
        BaseButton,
        PublicUserMenu,
        SearchMobile,
        SearchBoxHome,
        ...commonAsyncComponents,
        //@ts-ignore
        "place-modal": defineAsyncComponent(() => import("@vmodals/PlaceModal.vue")),
        //@ts-ignore
        "filters-modal": defineAsyncComponent(() => import("@vmodals/FiltersModal.vue")),
        //@ts-ignore
        "base-bt-modal": defineAsyncComponent(() => import("@vueEntry/BaseBtModal.vue")),
        //@ts-ignore
        "home-franchises-list": defineAsyncComponent(() => import("@vueEntry/HomeFranchisesList.vue")),
    },
    setup(){
        const {
            isDesktopMode,
            isSmall,
        } = useBreakpoints()

        const { isAppBannerVisible } = useAppBanner()

        const {
            showFirebaseSnackbar,
            snackbarTitle,
            snackbarBody,
            snackbarIcon,
            handleOnForegroundNotificationClick
        } = useFirebaseMessaging()

        return {
            isDesktopMode,
            isSmall,
            isAppBannerVisible,
            //useFirebaseMessaging
            showFirebaseSnackbar,
            snackbarTitle,
            snackbarBody,
            snackbarIcon,
            handleOnForegroundNotificationClick
        }
    },
    data() {
        return {
            showUsernameAliasModal: false,
            isIphone: false,
            publicUserConfirmed: false,
            publicUserFailedConfirm: false,
            mailAlertSuccess: true,
            showMessageSentSuccess: false,
            isAgencyActiveHome: false,
        }
    },
    computed: {
        ...mapState(useLoggedUserStore, ["isUserLogged"]),
        ...mapState(usePublicUserMenuStore, [
            "favoritesCounter", "requestsCounter", "savedSearchesCounter",
            "mailConfirmed", "name", "lastLoginDate", "email"
        ]),
        ...mapState(useEmailConfirmStore, ["passwordToken", "publicUserEmailConfirmSuccess"]),
        ...mapState(useModalStore, ["showModal"])
    },
    beforeCreate(): void {
        //Removing the redirect url if the user reloads the page!
        window.addEventListener("beforeunload", function (event) {
            localStorage.removeItem("redirect")
        });
    },
    created(): void {
        this.isIphone = window.navigator.userAgent.includes("iPhone");

        this.initPublicUserMenu().then(() => {

            this.publicUserConfirmed = window["_publicUserConfirmed"];
            this.publicUserFailedConfirm = window["_publicUserFailedConfirm"];

            if (!this.isUserLogged)
                return;

            if (!this.lastLoginDate)
                return;

            const dateNow = new Date();//moment();
            const lastLoginDate = new Date(this.lastLoginDate)//moment(window["_lastLoginDate"]);
            const daysToLastLogin = differenceInDays(dateNow, lastLoginDate)//dateNow.diff(lastLoginDate, "days");
            if (daysToLastLogin > 15)
                axios.get(`${window._baseURL}/rest/publicUser/updateUserLastLoginDate`);

        });
        //Inserting the token
        this.setPasswordToken();
        const curURL = window.location.href;
        //In case there is not a query string, the resultant object will be just empty
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.get("action") === "login") {
            //cleaning up the home url...
            const redirectUrl = searchParams.get("redirect");
            redirectUrl && localStorage.setItem("redirect", redirectUrl)
            history.pushState(null, "", "/")
            this.setShowModal(Modals.loginModal);
            return;
        }

        if (curURL.includes("recupero-password")) {
            this.setShowModal(Modals.setPwdModal);
        } else if (curURL.includes("conferma-email")) {
            this.setShowModal(Modals.mailConfirmedModal);
        } else
            this.setShowModal(Modals.noModal);

        if (window["_confirmedUsernameAlias"]) {
            this.showUsernameAliasModal = true;
        }

    },
    methods: {
        goToStore(): void {
            window.location.replace(this.isIphone
                ? "https://apps.apple.com/it/app/wikicasa/id1626038379"
                : "https://play.google.com/store/apps/details?id=it.wikicasa.wikicasa_app"
            );
            window.dataLayer.push({
                //GA4
                "event_name": "open_store",
                "event_location": "Home",
                "OS": this.isIphone ? "ios" : "android"
            });
        },
        cleanToken(): void {
            this.setPasswordToken("");
            this.setShowModal(Modals.updatePwdModal);
        },
        ...mapActions(useBaseStore, ["initPublicUserMenu"]),
        ...mapActions(useEmailConfirmStore, ["setPasswordToken"]),
        ...mapActions(useModalStore, ["setShowModal"])
        /*        ...mapActions(["initPublicUserMenu"]),
        ...mapMutations(["setPasswordToken", "setShowModal"])*/
    },
})
homeApp.use(createPinia())
homeApp.mount("#home-container")
